import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=1c91a8dc&scoped=true&"
var script = {}
import style0 from "./menu.vue?vue&type=style&index=0&id=1c91a8dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c91a8dc",
  null
  
)

export default component.exports